import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import {Request} from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';

import InnerLoader from './../../APP/COMPONENTS/InnerLoader';
import * as helpers from "./../../APP/HELPERS/functions"

function mapStateToProps(state) {
    return {
        USER: state.USER,
        SHOW_ELEMENTS: state.SHOW_ELEMENTS
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class AuthParts extends Component {

    /// CONSTRUCTOR ///
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        if (!this.props.USER || !this.props.SHOW_ELEMENTS) {
            return null
        }
        console.log('AUTH',this.props.SHOW_ELEMENTS)
        return (
            <div className="full_header">
                <Header />
                <LeftNav />
            </div>
        );
    }

}

export default connect(
    mapStateToProps, mapDispatchToProps
)(AuthParts);
